import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {uploadLVS3APIFORMOBILEAPP} from "../../API/uploadLV";
import validator from 'validator/es';
import { getUserInfo, sendEmail } from '../../API/user';

const LVUploadComponent = (props) => {

    const [s3UploadSuccess, setS3UploadSuccess] = React.useState(false)

    function isValid(value) {
        let receivedValue = value.trim();
        let rsl = false;

        if (receivedValue.length < 50) {
            rsl = true;
            receivedValue.split(/(?:[_ -])+/).forEach((word) => {
                rsl = rsl && validator.isAlphanumeric(word, 'de-DE');
            });
        }
        return rsl;
    }

    async function validateFile(fileNameKey, event) {

        const selectedFile = event.target.files;
        let fileName = selectedFile[0].name;
        //let projectID = sessionStorage.getItem("projectID")
        let projectID = props.appProjectID

        //S3 Info
        let lvFileName = fileName
        let lvFile = selectedFile[0]

        // Retrieve the file name excluding the file extension
        let lastIndex = fileName.lastIndexOf('.');
        let fileName_no_ext = fileName.substr(0, lastIndex);
        const fileExt = fileName.substr(lastIndex);

		if (!['.d83', '.x83', '.p83'].includes(fileExt.toLowerCase())) {
            let userData = await getUserInfo();
            const emailDetails = {
                emailtype: "lv_parse_failure",
                emaildetails: {
                    email: userData.em,
                    username: userData.fn,
                    //projectname: sessionStorage.getItem("projectName")
                    projectname: props.appProjectName
                }
            };
            sendEmail(emailDetails);
            const message = "Bitte überprüfen Sie den Dateityp. Es werden nur die Dateitypen x83, d83 und p83 unterstützt.";
            alert(message);
            return;
        }

        if (isValid(fileName_no_ext)) {
            // Once file name is validated, check the file size is within allowed limits.
            let fileSize = selectedFile[0].size;
            let fileSizeMB = fileSize / 1024 / 1024;
            if (fileSizeMB <= 70) {
                // Upload file to S3
                let s3ResponseCode = await uploadLVS3APIFORMOBILEAPP(projectID, lvFileName, lvFile)
                if (s3ResponseCode.httpStatusCode === 200) {
                    setS3UploadSuccess(true)
                    alert("LV erfolgreich hochgeladen")
                    props.setS3URL(s3ResponseCode.S3URL)
                    //sessionStorage.setItem("S3URL", s3ResponseCode.S3URL)
                } else {
                    console.log("check s3 upload")
                }

            } else {
                alert('Die Dateigröße darf 70 MB nicht überschreiten.')
            }

        } else {
            alert("Invalid File")
        }
    }


    return (

        <Row>

            <Col sm={1}/>
            <Col>
                <Form.Group controlId="GAEBfileUploadID">
                    {/*<Form.Label className='handwai-text-label-normal'>*/}
                    {/*    LV oder Materialliste*/}
                    {/*</Form.Label>*/}
                    <br/> <br/>
                    <Form.File
                        accept=".x83, .d83, .p83"
                        onChange={(event) => {
                            validateFile('GAEBfileUploadID', event).then(() => console.log(s3UploadSuccess));
                        }}
                    />
                </Form.Group>
            </Col>
            <Col sm={9}/>
        </Row>

    )

}

export default LVUploadComponent;